import { BrandType } from 'models/brand.model';
import { MealType } from 'models/meal.model';
import { CreatePostType } from 'models/posts.model';
import { createContext, useContext } from 'react';

export type PostContextType = {
  createPostForm: CreatePostType;
  setCreatePostForm: (k: CreatePostType) => void;
  disabled: boolean;
  setDisabled: (k: boolean) => void;
  brands: BrandType[];
  meals: MealType[];
  image: string;
  setImage: (val: string) => void;
};

export const CreatePostContext = createContext({} as PostContextType);

const useCreatePostContext = () => {
  const context = useContext(CreatePostContext);
  return context;
};

export default useCreatePostContext;
